import "./ReferralStatusUpdateBar.scss"

import React from 'react'
import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import { withRouter } from 'react-router'
import { createStructuredSelector } from 'reselect'
import { selectReferralLastUpdated } from 'manager/selectors/referral_selectors'

const UpdateBar = ({ lastUpdateAt, replace, location }) => {
    const { hash, pathname } = location

    const openStatus = () => {
      const query = { ...location.query, editstatus: true }
      replace({ hash, pathname, query })
    }

    const openHold = () => {
      const query = { ...location.query, hold: true }
      replace({ hash, pathname, query })
    }

    const openRelease = () => {
      const query = { ...location.query, release: true }
      replace({ hash, pathname, query })
    }

    return (
        <div className="ReferralStatusUpdateBar">
            <div className="Update">
                <button className="StatusButton__primary" onClick={openStatus}>
                    <span className="ButtonText">Update status</span>
                </button>
                {lastUpdateAt && <span className="Update__subtext">{`Last Update: ${lastUpdateAt}`}</span>}
            </div>
            <div className="Hold">
                <button className="StatusButton__secondary" onClick={openHold}>
                    <span className="ButtonText__blue">
                        <i className="fa fa-pause-circle"></i>
                        Hold
                    </span>
                </button>
            </div>
            <div className="Release">
                <button className="StatusButton__secondary" onClick={openRelease}>
                    <span className="ButtonText__blue">Release</span>
                </button>
            </div>
        </div>
    )
}

const selector = createStructuredSelector({
    lastUpdateAt: selectReferralLastUpdated
})

const actions = { replace }

const withRedux = connect(selector, actions)

export const ReferralStatusUpdateBar = withRedux(withRouter(UpdateBar))
